// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-site-container","content":"pages-site-content"};